<template>
  <div class="advantage-addition-wrapper">
    <div class="advantage-addition">
      <img src="/static/img/icons/delete.svg" class="delete-icon" 
        @click="deleteFunc(instanceObject.id)"
      />

      <b-field>
        <b-input placeholder="Заголовок" v-model="instanceObject.title"
          @change="updateFunc(instanceObject)"
        ></b-input>
      </b-field>

      <b-field v-if="useEditor">
        <Editor v-model="text" :editorToolbar="customToolbar" v-bind:id="`e${instanceObject.id}`"/>
      </b-field>

      <b-field v-else>
        <b-input placeholder="Текст" type="textarea" v-model="instanceObject.description"
          @change="updateFunc(instanceObject)"
        ></b-input>
      </b-field>
    </div>
  </div>
</template>

<script>
  import { VueEditor as Editor } from 'vue2-editor'
  import deepcopy from 'deepcopy'

  export default {
    name: 'AdvantageOrReason',
    data () {
      return {
        text: '',
        customToolbar: [
          ['bold', 'italic', 'underline'],
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{'align': ''}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
          ['link']
        ]
      }
    },

    computed: {
      instanceObject () {
        if (this.instance) {
          this.text = this.instance.description
          return deepcopy(this.instance)
        }
      }
    },

    props: {
      instance: {
        type: Object,
        required: true
      },
      deleteFunc: {
        type: Function,
        required: true
      },
      updateFunc: {
        type: Function,
        required: true
      },
      useEditor: {
        type: Boolean,
        required: true
      }
    },

    watch: {
      text () {
        this.instanceObject.description = this.text
        this.updateFunc(this.instanceObject)
      }
    },

    components: { Editor }
  }
</script>

<style>
.advantage-addition-wrapper {
  background: #eeeeee;
  padding: 30px;
  margin: 20px 0px;
}

.advantage-addition, .service-description {
  max-width: 600px;
  margin: 0 auto;
  position: relative;
}

.delete-icon {
  width: 24px;
  position: absolute;
  top: -20px;
  right: -20px;
  z-index: 100;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// AdvantageOrReason.vue?7dc0655a